import React, { ReactElement } from 'react';
import { Col, Row, Text } from 'rsuite';
import FormTextField from '../../../components/form/FormTextField';
import { FORM_INPUT_TYPES, INPUT_TYPE } from 'src/common/enums';
import { OccupancyError, OccupancyReport } from 'src/types/tax';

interface PropertyOccupancyRowProps {
  error?: OccupancyError;
  name: string;
  value?: OccupancyReport;
}

export const PropertyOccupancy = ({
  error,
  name,
  value,
}: PropertyOccupancyRowProps): ReactElement => {
  return (
    <Row className="report-revenue-row">
      <Col
        xs={24}
        md={12}
      >
        <Text
          as="h5"
          style={{ margin: '12px 0' }}
        >
          Property Occupancy
        </Text>
      </Col>
      <Col
        xs={12}
        md={6}
      >
        <FormTextField
          errorMessage={error?.available}
          hasError={!!error?.available}
          inputFieldType={INPUT_TYPE.NUMBER}
          inputMode="numeric"
          label="No. Days Available"
          labelClass="text-small"
          key={`${name}.available`}
          name={`${name}.occupancy.available`}
          trimEndOnChange
          trimStartOnChange
          type={FORM_INPUT_TYPES.NUMBER}
          value={value?.available}
        />
      </Col>
      <Col
        xs={12}
        md={6}
      >
        <FormTextField
          errorMessage={error?.occupied}
          hasError={!!error?.occupied}
          inputFieldType={INPUT_TYPE.NUMBER}
          inputMode="numeric"
          label="No. Days Occupied"
          labelClass="text-small"
          key={`${name}.occupied`}
          name={`${name}.occupancy.occupied`}
          trimEndOnChange
          trimStartOnChange
          type={FORM_INPUT_TYPES.NUMBER}
          value={value?.occupied}
        />
      </Col>
    </Row>
  );
};
